import cx from 'classnames';
import { AppContext } from 'contexts/v2/app-context';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { Skeleton } from 'components/ui/skeleton';

interface HomeBannerProps {
  showBackground: boolean;
}

export function HomeBanner({ showBackground = true }: HomeBannerProps) {
  const { brandName } = useContext(AppContext);

  return (
    <div
      className={cx(
        'min-h-34 flex w-full flex-col items-center justify-center px-4 py-3.5 sm:px-8 md:px-16 lg:px-36',
        {
          'from-primary-600 to-primary-900 bg-gradient-to-r': showBackground,
        },
      )}
    >
      <h1
        className={cx('text-center text-3xl font-medium', {
          'text-primary-foreground': showBackground,
        })}
      >
        <FormattedMessage
          defaultMessage="Find your next opportunity at {brandName}"
          description="Find your next opportunity at brand name"
          values={{
            brandName: <span className="whitespace-nowrap">{brandName}</span>,
          }}
        />
      </h1>
    </div>
  );
}

HomeBanner.Skeleton = function HomeBannerSkeleton() {
  return <Skeleton className="h-full w-full" />;
};
